<template>
  <v-card rounded="xl" elevation="0" border class="agent-card h-100">
    <v-card-text class="pa-5 d-flex flex-column" style="height:100%">

      <!-- Top row: category -->
      <div class="d-flex align-center justify-end mb-4">
        <v-chip size="small" :color="categoryColor" variant="tonal" class="text-capitalize font-weight-medium">
          {{ categoryLabel }}
        </v-chip>
      </div>

      <!-- Name & group (clickable → detail page) -->
      <div class="flex-grow-1 agent-name-block" @click="$emit('view', agent.id)" style="cursor:pointer">
        <h3 class="agent-name mb-1">{{ agent.name }}</h3>
        <p class="text-body-2 text-medium-emphasis">{{ agent.groupName }}</p>
      </div>

      <!-- Meta info -->
      <div class="meta-grid mt-4 mb-4">
        <div class="meta-row">
          <v-icon size="14" color="grey-darken-1">mdi-identifier</v-icon>
          <span class="text-caption text-medium-emphasis ml-1">{{ agent.profileId }}</span>
        </div>
      </div>

      <!-- Actions -->
      <div class="d-flex align-center justify-end">
        <v-menu location="bottom end">
          <template #activator="{ props }">
            <v-btn v-bind="props" size="small" variant="text" icon="mdi-dots-vertical" density="comfortable" />
          </template>
          <v-list density="compact" rounded="lg" elevation="4" min-width="180">
            <v-list-item prepend-icon="mdi-open-in-new" title="View Details" @click="$emit('view', agent.id)" />
            <v-divider class="my-1" />
            <v-list-item
              prepend-icon="mdi-delete-outline"
              title="Remove"
              base-color="error"
              @click="$emit('delete', agent.id)"
            />
          </v-list>
        </v-menu>
      </div>

    </v-card-text>
  </v-card>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'ClassMomCard',
  props: {
    agent: { type: Object, required: true }
  },
  emits: ['edit', 'delete', 'view'],
  setup(props) {
    const categoryLabel = computed(() => {
      return { class: 'Class', grade: 'Grade', sport: 'Sport', extramural: 'Extramural' }[props.agent.category] || props.agent.category
    })

    const categoryColor = computed(() => {
      return { class: 'blue', grade: 'purple', sport: 'green', extramural: 'orange' }[props.agent.category] || 'grey'
    })

    return { categoryLabel, categoryColor }
  }
}
</script>

<style scoped>
.agent-card {
  transition: box-shadow 0.2s ease;
}
.agent-card:hover {
  box-shadow: 0 4px 24px rgba(0,0,0,0.08) !important;
}
.agent-name {
  font-size: 1rem;
  font-weight: 700;
  color: #1a1a2e;
  line-height: 1.3;
}
.meta-row {
  display: flex;
  align-items: center;
}
</style>
